import React from 'react'
import PropTypes from 'prop-types'
import { StatisticsOnboardingItems } from '../../organism'
import { MODULES } from '../../../config/constants'

const Statistics = ({ classes }) => (
  <div className={classes.root}>
    <StatisticsOnboardingItems module={MODULES.ID_ON_BOARDING} />
  </div>
)

Statistics.propTypes = {
  classes: PropTypes.object.isRequired
}

export default Statistics
